import http from '../../utils/http'
import {
	CONFIGURATIONS_BATCH_UPDATE,
	CONFIGURATIONS_INIT,
	CONFIGURATIONS_ITEM_EDIT,
	CONFIGURATIONS_ITEM_STRUCTURE,
	CONFIGURATIONS_ITEM_TABLE,
	CONFIGURATIONS_ITEM_VIEW,
	CONFIGURATIONS_PERMISSIONS,
	CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST,
	CONFIGURATIONS_TABLE_FILTER,
	UPDATE_ITEM_DATA
} from 'actions/configurations'
import { AUTH_LOGOUT } from 'actions/authentication'
import Vue from 'vue'

const state = {
	ITEM_STRUCTURE: JSON.parse(localStorage.getItem('ITEM_STRUCTURE')) || {
		data: [],
		etag: ''
	},
	TABLE_COLUMNS: JSON.parse(localStorage.getItem('TABLE_COLUMNS')) || {
		data: [],
		etag: ''
	},
	DB_FILTER_ATTRIBUTES: JSON.parse(localStorage.getItem('DB_FILTER_ATTRIBUTES')) || {
		data: [],
		etag: ''
	},
	ATTRIBUTES_GROUPS: JSON.parse(localStorage.getItem('ATTRIBUTES_GROUPS')) || {
		data: [],
		etag: ''
	},
	ITEM_PK: JSON.parse(localStorage.getItem('ITEM_PK')) || {
		data: [],
		etag: ''
	},
	LANGUAGES: JSON.parse(localStorage.getItem('LANGUAGES')) || {
		data: [],
		etag: ''
	},
	ITEM_VALIDATION_RULES: JSON.parse(localStorage.getItem('ITEM_VALIDATION_RULES')) || {
		data: [],
		etag: ''
	},
	prevValuesDictionary: [],
	CLASSIFICATORS: JSON.parse(localStorage.getItem('CLASSIFICATORS')) || {
		data: [],
		etag: ''
	},
	MEASUREMENT_UNITS: JSON.parse(localStorage.getItem('MEASUREMENT_UNITS')) || {
		data: [],
		etag: ''
	},
	permissions: [],
	itemData: [],
	countries: JSON.parse(localStorage.getItem('countries')) || [],
	person: JSON.parse(localStorage.getItem('person')) || [],
	recalculateAttributesList: JSON.parse(localStorage.getItem('recalculateAttributesList')) || [],
	loading: false,
	isCreatePage: false
}

const ITEM_STRUCTURE = () => http.get('config/trade-item-structure')
const ITEM_ENRICHMENT = () => http.get('config/item-enrichment')
const TABLE_COLUMNS = () => http.get('config/table-columns')
const DB_FILTER_ATTRIBUTES = () => http.get('config/db-filter')
const ATTRIBUTES_GROUPS = () => http.get('config/attributes-groups')
const ITEM_PK = () => http.get('config/trade-item-structure/pk')
const LANGUAGES = () => http.get('config/std-codes/languages')
const ITEM_VALIDATION_RULES = () => http.get('config/item-validation/status-rules')
const prevValuesDictionary = () => http.get('items/prev-values')
const CLASSIFICATORS = () => http.get('config/std-codes/classificators')
const MEASUREMENT_UNITS = () => http.get('config/std-codes/measurement-units')
const LOCALIZATION_MESSAGES = () => http.get('config/localization-messages')
const permissions = () => http.post('/permission/list')
const itemData = (url) => url ? http.get(url) : { data: {} }
const countries = () => http.get('/countries')
const person = () => http.get('/person/me')

export const checkConfigUpdate = (configs) => http.get('/config/update/check', {
	params: configs
})

const getters = {
	getDbFilter: (state) => state.DB_FILTER_ATTRIBUTES.data,
	getItemStructure: (state) => state.ITEM_STRUCTURE.data,
	getTableColumn: (state) => state.TABLE_COLUMNS.data,
	getAttributesGroups: (state) => state.ATTRIBUTES_GROUPS.data,
	getItemPk: (state) => state.ITEM_PK.data["attributeNames"],
	getLanguage: (state) => state.LANGUAGES.data,
	getItemValidationRules: (state) => state.ITEM_VALIDATION_RULES.data,
	getPrevValuesDictionary: (state) => state.prevValuesDictionary,
	getClassificators: (state) => state.CLASSIFICATORS.data,
	getMeasurementUnits: (state) => state.MEASUREMENT_UNITS.data,
	getPerson: (state) => state.person,
	getPermissionsList: (state) => state.permissions,
	getItemData: (state) => state.itemData,
	getCountries: (state) => state.countries,
	getRecalculateAttributesList: state => state.recalculateAttributesList,
	getLoadingStatus: state => state.loading
}

const actions = {
	[CONFIGURATIONS_INIT]: ({ commit, dispatch }) => {
		return http.all([
			ITEM_STRUCTURE(),
			// ITEM_ENRICHMENT(),
			TABLE_COLUMNS(),
			DB_FILTER_ATTRIBUTES(),
			ATTRIBUTES_GROUPS(),
			ITEM_PK(),
			LANGUAGES(),
			ITEM_VALIDATION_RULES(),
			CLASSIFICATORS(),
			MEASUREMENT_UNITS(),
			countries(),
			person()
		])
			.then(http.spread((
				ITEM_STRUCTURE,
				// ITEM_ENRICHMENT,
				TABLE_COLUMNS,
				DB_FILTER_ATTRIBUTES,
				ATTRIBUTES_GROUPS,
				ITEM_PK,
				LANGUAGES,
				ITEM_VALIDATION_RULES,
				CLASSIFICATORS,
				MEASUREMENT_UNITS,
				countries,
				person
			) => {
				commit(CONFIGURATIONS_INIT, {
					ITEM_STRUCTURE,
					// ITEM_ENRICHMENT,
					TABLE_COLUMNS,
					DB_FILTER_ATTRIBUTES,
					ATTRIBUTES_GROUPS,
					ITEM_PK,
					LANGUAGES,
					ITEM_VALIDATION_RULES,
					CLASSIFICATORS,
					MEASUREMENT_UNITS,
					countries,
					person
				})
				dispatch(CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST, ITEM_STRUCTURE.data)
			}))
			.catch(errors => {
				console.error(errors)
				Vue.rollbar.error('CONFIGURATIONS_INIT', errors)
			})
	},
	[CONFIGURATIONS_TABLE_FILTER]: ({ commit, state }) => {
		return new Promise(resolve => {
			checkConfigUpdate({
				CLASSIFICATORS: state.CLASSIFICATORS.etag,
				MEASUREMENT_UNITS: state.MEASUREMENT_UNITS.etag,
			}).then((resp) => {
				if (resp.data.length === 0) {
					resolve()
				} else {
					let data = {
						CLASSIFICATORS,
						MEASUREMENT_UNITS,
					}
					let res = []
					resp.data.forEach(item => {
						res.push(data[item]())
					})

					http.all(res)
						.then(http.spread((...response) => {
							let config = {}
							resp.data.forEach((item, i) => {
								config[item] = response[i]
							})
							commit(CONFIGURATIONS_TABLE_FILTER, config)
							resolve()
						}))
						.catch(errors => {
							console.error(errors)
							Vue.rollbar.error('CONFIGURATIONS_TABLE_FILTER', errors)
						})
				}
			}).catch(errors => {
				console.error(errors)
				Vue.rollbar.error('CHECK_CONFIG_UPDATE', errors)
			})
		})
	},
	[CONFIGURATIONS_ITEM_TABLE]: ({ commit, state }) => {
		return new Promise(resolve => {
			checkConfigUpdate({
				ITEM_STRUCTURE: state.ITEM_STRUCTURE.etag,
				TABLE_COLUMNS: state.TABLE_COLUMNS.etag,
				DB_FILTER_ATTRIBUTES: state.DB_FILTER_ATTRIBUTES.etag,
			}).then((resp) => {
				if (resp.data.length === 0) {
					resolve()
				} else {
					let data = {
						ITEM_STRUCTURE,
						TABLE_COLUMNS,
						DB_FILTER_ATTRIBUTES,
					}
					let res = []
					resp.data.forEach(item => {
						res.push(data[item]())
					})

					http.all(res)
						.then(http.spread((...response) => {
							let config = {}
							resp.data.forEach((item, i) => {
								config[item] = response[i]
							})
							commit(CONFIGURATIONS_ITEM_TABLE, config)
							resolve()
						}))
						.catch(errors => {
							console.error(errors)
							Vue.rollbar.error('CONFIGURATIONS_ITEM_TABLE', errors)
						})
				}
			}).catch(errors => {
				console.error(errors)
				Vue.rollbar.error('CHECK_CONFIG_UPDATE', errors)
			})
		})
	},
	[CONFIGURATIONS_ITEM_EDIT]: ({ commit, state, dispatch }, url) => {
		let vm = this
		commit('loading', true)
		return http.all([
			prevValuesDictionary(),
			person(),
			itemData(url)
		])
			.then(http.spread((
				prevValuesDictionary,
				person,
				itemData
			) => {
				return new Promise(resolve => {
					checkConfigUpdate({
						ITEM_STRUCTURE: state.ITEM_STRUCTURE.etag,
						TABLE_COLUMNS: state.TABLE_COLUMNS.etag,
						ATTRIBUTES_GROUPS: state.ATTRIBUTES_GROUPS.etag,
						ITEM_PK: state.ITEM_PK.etag,
						LANGUAGES: state.LANGUAGES.etag,
						ITEM_VALIDATION_RULES: state.ITEM_VALIDATION_RULES.etag,
						CLASSIFICATORS: state.CLASSIFICATORS.etag,
						MEASUREMENT_UNITS: state.MEASUREMENT_UNITS.etag,
					}).then((resp) => {
						if (resp.data.length === 0) {
							commit(CONFIGURATIONS_ITEM_EDIT, {
								prevValuesDictionary,
								person,
								itemData
							})
							if (state.recalculateAttributesList.length === 0) {
								dispatch(CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST, state.ITEM_STRUCTURE.data)
							}
							commit('loading', false)
							resolve()
						} else {
							let data = {
								ITEM_STRUCTURE,
								TABLE_COLUMNS,
								ATTRIBUTES_GROUPS,
								ITEM_PK,
								LANGUAGES,
								ITEM_VALIDATION_RULES,
								CLASSIFICATORS,
								MEASUREMENT_UNITS,
							}
							let res = []
							resp.data.forEach(item => {
								res.push(data[item]())
							})

							http.all(res)
								.then(http.spread((...response) => {
									let config = {}
									resp.data.forEach((item, i) => {
										config[item] = response[i]
									})
									config['prevValuesDictionary'] = prevValuesDictionary
									config['person'] = person
									config['itemData'] = itemData
									commit(CONFIGURATIONS_ITEM_EDIT, config)
									if (state.recalculateAttributesList.length === 0) {
										if (config['ITEM_STRUCTURE']) {
											dispatch(CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST, config['ITEM_STRUCTURE'].data)
										} else {
											dispatch(CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST, state.ITEM_STRUCTURE.data)
										}
									}
									commit('loading', false)
									resolve()
								}))
								.catch(errors => {
									console.error(errors)
									Vue.rollbar.error('CONFIGURATIONS_ITEM_EDIT', errors)
								})
						}
					}).catch(errors => {
						console.error(errors)
						Vue.rollbar.error('CHECK_CONFIG_UPDATE', errors)
					})
				})
			}))
			.catch(errors => {
				console.error(errors, 'CONFIGURATIONS_ITEM_EDIT')
				Vue.rollbar.error('CONFIGURATIONS_ITEM_EDIT', errors)

				commit('loading', false)
			})
	},
	[CONFIGURATIONS_ITEM_VIEW]: ({ commit }, url) => {
		commit('loading', true)
		return itemData(url)
			.then(itemData => {
				return new Promise(resolve => {
					checkConfigUpdate({
						ITEM_STRUCTURE: state.ITEM_STRUCTURE.etag,
						ATTRIBUTES_GROUPS: state.ATTRIBUTES_GROUPS.etag,
						LANGUAGES: state.LANGUAGES.etag,
					}).then((resp) => {
						if (resp.data.length === 0) {
							commit(CONFIGURATIONS_ITEM_VIEW, {
								itemData
							})
							commit('loading', false)
							resolve()
						} else {
							let data = {
								ITEM_STRUCTURE,
								ATTRIBUTES_GROUPS,
								LANGUAGES
							}
							let res = []
							resp.data.forEach(item => {
								res.push(data[item]())
							})

							http.all(res)
								.then(http.spread((...response) => {
									let config = {}
									resp.data.forEach((item, i) => {
										config[item] = response[i]
									})
									config['itemData'] = itemData
									commit(CONFIGURATIONS_ITEM_VIEW, config)
									commit('loading', false)
									resolve()
								}))
								.catch(errors => {
									console.error(errors)
									Vue.rollbar.error('CONFIGURATIONS_ITEM_VIEW', errors)
								})
						}
					}).catch(errors => {
						console.error(errors)
						Vue.rollbar.error('CHECK_CONFIG_UPDATE', errors)
					})
				})
			})
			.catch(errors => {
				console.error(errors)
				Vue.rollbar.error('CONFIGURATIONS_ITEM_EDIT', errors)

				commit('loading', false)
			})
	},
	[CONFIGURATIONS_ITEM_STRUCTURE]: ({ commit }) => {
		return new Promise(resolve => {
			checkConfigUpdate({
				ITEM_STRUCTURE: state.ITEM_STRUCTURE.etag,
				ATTRIBUTES_GROUPS: state.ATTRIBUTES_GROUPS.etag,
				ITEM_VALIDATION_RULES: state.ITEM_VALIDATION_RULES.etag,
			}).then((resp) => {
				if (resp.data.length === 0) {
					resolve()
				} else {
					let data = {
						ITEM_STRUCTURE,
						ATTRIBUTES_GROUPS,
						ITEM_VALIDATION_RULES
					}
					let res = []
					resp.data.forEach(item => {
						res.push(data[item]())
					})

					http.all(res)
						.then(http.spread((...response) => {
							let config = {}
							resp.data.forEach((item, i) => {
								config[item] = response[i]
							})
							commit(CONFIGURATIONS_ITEM_STRUCTURE, config)
							resolve()
						}))
						.catch(errors => {
							console.error(errors)
							Vue.rollbar.error('CONFIGURATIONS_TABLE_FILTER', errors)
						})
				}
			}).catch(errors => {
				console.error(errors)
				Vue.rollbar.error('CHECK_CONFIG_UPDATE', errors)
			})
		})
	},
	[CONFIGURATIONS_PERMISSIONS]: ({ commit }) => {
		return http.all([
			permissions()
		])
			.then(http.spread((
				permissions
			) => {
				commit(CONFIGURATIONS_PERMISSIONS, {
					permissions
				})
			}))
			.catch(errors => {
				console.error(errors)
				Vue.rollbar.error('CONFIGURATIONS_PERMISSIONS', errors)
			})
	},
	[CONFIGURATIONS_BATCH_UPDATE]: ({ commit }) => {
		return http.all([
			prevValuesDictionary(),
			person()
		])
			.then(http.spread((
				prevValuesDictionary,
				person
			) => {
				return {
					person: person.data,
					prevValuesDictionary: prevValuesDictionary.data
				}
			}))
			.catch(errors => {
				console.error(errors)
				Vue.rollbar.error('CONFIGURATIONS_BATCH_UPDATE', errors)
			})
	},
	[UPDATE_ITEM_DATA]: ({ commit }, data) => {
		commit(UPDATE_ITEM_DATA, data)
	},
	[CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST]: ({ commit, state }, itemStructure) => {
		let resultArray = []
		for (let key in itemStructure) {
			if (!itemStructure[key].hasOwnProperty('expression')) {
				continue
			} else {
				resultArray.push(key)
			}
		}
		commit(CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST, resultArray)
	}
}

const mutations = {
	[CONFIGURATIONS_INIT]: (state, config) => {
		state.ITEM_STRUCTURE = {
			data: config.ITEM_STRUCTURE.data,
			etag: config.ITEM_STRUCTURE.headers.etag.split('"')[1]
		}
		state.TABLE_COLUMNS = {
			data: config.TABLE_COLUMNS.data,
			etag: config.TABLE_COLUMNS.headers.etag.split('"')[1]
		}
		state.DB_FILTER_ATTRIBUTES = {
			data: config.DB_FILTER_ATTRIBUTES.data,
			etag: config.DB_FILTER_ATTRIBUTES.headers.etag.split('"')[1]
		}
		state.ATTRIBUTES_GROUPS = {
			data: config.ATTRIBUTES_GROUPS.data,
			etag: config.ATTRIBUTES_GROUPS.headers.etag.split('"')[1]
		}
		state.ITEM_PK = {
			data: config.ITEM_PK.data,
			etag: config.ITEM_PK.headers.etag.split('"')[1]
		}
		state.LANGUAGES = {
			data: config.LANGUAGES.data,
			etag: config.LANGUAGES.headers.etag.split('"')[1]
		}
		state.ITEM_VALIDATION_RULES = {
			data: config.ITEM_VALIDATION_RULES.data,
			etag: config.ITEM_VALIDATION_RULES.headers.etag.split('"')[1]
		}
		state.CLASSIFICATORS = {
			data: config.CLASSIFICATORS.data,
			etag: config.CLASSIFICATORS.headers.etag.split('"')[1]
		}
		state.MEASUREMENT_UNITS = {
			data: config.MEASUREMENT_UNITS.data,
			etag: config.MEASUREMENT_UNITS.headers.etag.split('"')[1]
		}
		state.countries = config.countries.data
		state.person = config.person.data
		localStorage.setItem('ITEM_STRUCTURE', JSON.stringify(state.ITEM_STRUCTURE))
		localStorage.setItem('TABLE_COLUMNS', JSON.stringify(state.TABLE_COLUMNS))
		localStorage.setItem('DB_FILTER_ATTRIBUTES', JSON.stringify(state.DB_FILTER_ATTRIBUTES))
		localStorage.setItem('ATTRIBUTES_GROUPS', JSON.stringify(state.ATTRIBUTES_GROUPS))
		localStorage.setItem('ITEM_PK', JSON.stringify(state.ITEM_PK))
		localStorage.setItem('LANGUAGES', JSON.stringify(state.LANGUAGES))
		localStorage.setItem('ITEM_VALIDATION_RULES', JSON.stringify(state.ITEM_VALIDATION_RULES))
		localStorage.setItem('CLASSIFICATORS', JSON.stringify(state.CLASSIFICATORS))
		localStorage.setItem('MEASUREMENT_UNITS', JSON.stringify(state.MEASUREMENT_UNITS))
		localStorage.setItem('countries', JSON.stringify(state.countries))
		localStorage.setItem('person', JSON.stringify(state.person))
	},
	'CONFIGURATIONS_CLEAR': (state) => {
		localStorage.removeItem('ITEM_STRUCTURE')
		localStorage.removeItem('TABLE_COLUMNS')
		localStorage.removeItem('DB_FILTER_ATTRIBUTES')
		localStorage.removeItem('ATTRIBUTES_GROUPS')
		localStorage.removeItem('ITEM_PK')
		localStorage.removeItem('LANGUAGES')
		localStorage.removeItem('ITEM_VALIDATION_RULES')
		localStorage.removeItem('CLASSIFICATORS')
		localStorage.removeItem('MEASUREMENT_UNITS')
		localStorage.removeItem('countries')
		localStorage.removeItem('person')
		localStorage.removeItem('itemsTable')
	},
	[CONFIGURATIONS_ITEM_TABLE]: (state, config) => {
		if (config.ITEM_STRUCTURE) {
			state.ITEM_STRUCTURE = {
				data: config.ITEM_STRUCTURE.data,
				etag: config.ITEM_STRUCTURE.headers.etag.split('"')[1]
			}
			localStorage.setItem('ITEM_STRUCTURE', JSON.stringify(state.ITEM_STRUCTURE))
		}
		if (config.TABLE_COLUMNS) {
			state.TABLE_COLUMNS = {
				data: config.TABLE_COLUMNS.data,
				etag: config.TABLE_COLUMNS.headers.etag.split('"')[1]
			}
			localStorage.setItem('TABLE_COLUMNS', JSON.stringify(state.TABLE_COLUMNS))
		}
		if (config.DB_FILTER_ATTRIBUTES) {
			state.DB_FILTER_ATTRIBUTES = {
				data: config.DB_FILTER_ATTRIBUTES.data,
				etag: config.DB_FILTER_ATTRIBUTES.headers.etag.split('"')[1]
			}
			localStorage.setItem('DB_FILTER_ATTRIBUTES', JSON.stringify(state.DB_FILTER_ATTRIBUTES))
		}
	},
	[CONFIGURATIONS_ITEM_EDIT]: (state, config) => {
		if (config.prevValuesDictionary) {
			state.prevValuesDictionary = config.prevValuesDictionary.data
		}
		if (config.person) {
			state.person = config.person.data
		}
		if (config.itemData) {
			state.itemData = config.itemData.data
		}
		if (config.ITEM_STRUCTURE) {
			state.ITEM_STRUCTURE = {
				data: config.ITEM_STRUCTURE.data,
				etag: config.ITEM_STRUCTURE.headers.etag.split('"')[1]
			}
			localStorage.setItem('ITEM_STRUCTURE', JSON.stringify(state.ITEM_STRUCTURE))
		}
		if (config.TABLE_COLUMNS) {
			state.TABLE_COLUMNS = {
				data: config.TABLE_COLUMNS.data,
				etag: config.TABLE_COLUMNS.headers.etag.split('"')[1]
			}
			localStorage.setItem('TABLE_COLUMNS', JSON.stringify(state.TABLE_COLUMNS))
		}
		if (config.ATTRIBUTES_GROUPS) {
			state.ATTRIBUTES_GROUPS = {
				data: config.ATTRIBUTES_GROUPS.data,
				etag: config.ATTRIBUTES_GROUPS.headers.etag.split('"')[1]
			}
			localStorage.setItem('ATTRIBUTES_GROUPS', JSON.stringify(state.ATTRIBUTES_GROUPS))
		}
		if (config.ITEM_PK) {
			state.ITEM_PK = {
				data: config.ITEM_PK.data,
				etag: config.ITEM_PK.headers.etag.split('"')[1]
			}
			localStorage.setItem('ITEM_PK', JSON.stringify(state.ITEM_PK))
		}
		if (config.LANGUAGES) {
			state.LANGUAGES = {
				data: config.LANGUAGES.data,
				etag: config.LANGUAGES.headers.etag.split('"')[1]
			}
			localStorage.setItem('LANGUAGES', JSON.stringify(state.LANGUAGES))
		}
		if (config.ITEM_VALIDATION_RULES) {
			state.ITEM_VALIDATION_RULES = {
				data: config.ITEM_VALIDATION_RULES.data,
				etag: config.ITEM_VALIDATION_RULES.headers.etag.split('"')[1]
			}
			localStorage.setItem('ITEM_VALIDATION_RULES', JSON.stringify(state.ITEM_VALIDATION_RULES))
		}
		if (config.CLASSIFICATORS) {
			state.CLASSIFICATORS = {
				data: config.CLASSIFICATORS.data,
				etag: config.CLASSIFICATORS.headers.etag.split('"')[1]
			}
			localStorage.setItem('CLASSIFICATORS', JSON.stringify(state.CLASSIFICATORS))
		}
		if (config.MEASUREMENT_UNITS) {
			state.MEASUREMENT_UNITS = {
				data: config.MEASUREMENT_UNITS.data,
				etag: config.MEASUREMENT_UNITS.headers.etag.split('"')[1]
			}
			localStorage.setItem('MEASUREMENT_UNITS', JSON.stringify(state.MEASUREMENT_UNITS))
		}
	},
	[CONFIGURATIONS_ITEM_VIEW]: (state, config) => {
		if (config.itemData) {
			state.itemData = config.itemData.data
		}

		if (config.ITEM_STRUCTURE) {
			state.ITEM_STRUCTURE = {
				data: config.ITEM_STRUCTURE.data,
				etag: config.ITEM_STRUCTURE.headers.etag.split('"')[1]
			}
			localStorage.setItem('ITEM_STRUCTURE', JSON.stringify(state.ITEM_STRUCTURE))
		}
		if (config.ATTRIBUTES_GROUPS) {
			state.ATTRIBUTES_GROUPS = {
				data: config.ATTRIBUTES_GROUPS.data,
				etag: config.ATTRIBUTES_GROUPS.headers.etag.split('"')[1]
			}
			localStorage.setItem('ATTRIBUTES_GROUPS', JSON.stringify(state.ATTRIBUTES_GROUPS))
		}
		if (config.LANGUAGES) {
			state.LANGUAGES = {
				data: config.LANGUAGES.data,
				etag: config.LANGUAGES.headers.etag.split('"')[1]
			}
			localStorage.setItem('LANGUAGES', JSON.stringify(state.LANGUAGES))
		}
	},
	[CONFIGURATIONS_ITEM_STRUCTURE]: (state, config) => {
		if (config.ITEM_STRUCTURE) {
			state.ITEM_STRUCTURE = {
				data: config.ITEM_STRUCTURE.data,
				etag: config.ITEM_STRUCTURE.headers.etag.split('"')[1]
			}
			localStorage.setItem('ITEM_STRUCTURE', JSON.stringify(state.ITEM_STRUCTURE))
		}
		if (config.ATTRIBUTES_GROUPS) {
			state.ATTRIBUTES_GROUPS = {
				data: config.ATTRIBUTES_GROUPS.data,
				etag: config.ATTRIBUTES_GROUPS.headers.etag.split('"')[1]
			}
			localStorage.setItem('ATTRIBUTES_GROUPS', JSON.stringify(state.ATTRIBUTES_GROUPS))
		}
		if (config.ITEM_VALIDATION_RULES) {
			state.ITEM_VALIDATION_RULES = {
				data: config.ITEM_VALIDATION_RULES.data,
				etag: config.ITEM_VALIDATION_RULES.headers.etag.split('"')[1]
			}
			localStorage.setItem('ITEM_VALIDATION_RULES', JSON.stringify(state.ITEM_VALIDATION_RULES))
		}
	},
	[CONFIGURATIONS_PERMISSIONS]: (state, config) => {
		state.permissions = config.permissions.data
	},
	[CONFIGURATIONS_TABLE_FILTER]: (state, config) => {
		if (config.CLASSIFICATORS) {
			state.CLASSIFICATORS = {
				data: config.CLASSIFICATORS.data,
				etag: config.CLASSIFICATORS.headers.etag.split('"')[1]
			}
			localStorage.setItem('CLASSIFICATORS', JSON.stringify(state.CLASSIFICATORS))
		}
		if (config.MEASUREMENT_UNITS) {
			state.MEASUREMENT_UNITS = {
				data: config.MEASUREMENT_UNITS.data,
				etag: config.MEASUREMENT_UNITS.headers.etag.split('"')[1]
			}
			localStorage.setItem('MEASUREMENT_UNITS', JSON.stringify(state.MEASUREMENT_UNITS))
		}
	},
	[UPDATE_ITEM_DATA]: (state, data) => {
		state.itemData = data
	},
	[CONFIGURATIONS_RECALCULATE_ATTRIBUTES_LIST]: (state, attributes) => {
		state.recalculateAttributesList = attributes
		localStorage.setItem('recalculateAttributesList', JSON.stringify(attributes))
	},
	'loading': (state, status) => {
		state.loading = status
	},
	'IS_CREATE_PAGE': (state, status) => {
		state.isCreatePage = status
	},
	[AUTH_LOGOUT]: (state) => {
		state.person = []
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
